import { useI18n } from '@/i18n/useI18n';
import type { Language } from '@/i18n/translations';
import { cn } from '@/lib/utils';

const LANGUAGES: Language[] = ['ru', 'en'];

const LANGUAGE_LABELS: Record<Language, string> = {
  ru: 'Ру',
  en: 'En',
};

export function LanguageSwitcher({ className }: { className?: string }) {
  const { language, setLanguage, t } = useI18n();

  return (
    <div
      role="group"
      aria-label={t('language.label')}
      className={cn('flex w-fit items-center rounded-full bg-muted p-0.5 text-xs', className)}
    >
      {LANGUAGES.map((item) => (
        <button
          key={item}
          type="button"
          aria-pressed={language === item}
          className={cn(
            'cursor-pointer rounded-full px-2.5 py-1.5 font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
            language === item
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground',
          )}
          onClick={() => setLanguage(item)}
        >
          {LANGUAGE_LABELS[item]}
        </button>
      ))}
    </div>
  );
}
